import React, { useEffect, useState } from 'react';
import { appWrap, MotionWrap } from '../../wrapper';
import './About.scss';
import { motion } from 'framer-motion';
import { urlFor, client } from '../../client';

// const about = [
//   {
//     title: 'Web Development',
//     description: 'hahhaa',
//     imgUrl: images.about01,
//   },
//   {
//     title: 'Frontend Development',
//     description: 'react',
//     imgUrl: images.about02
//   },
//   {
//     title: 'Backend Development',
//     description: 'react',
//     imgUrl: images.about03
//   },
//   {
//     title: 'Mobile Development',
//     description: 'react',
//     imgUrl: images.about04
//   },

// ];

const About = () => {

  const [about, setAbout] = useState([]);

  useEffect(() => {
    const query = `*[_type == "abouts"]`;
    client.fetch(query).then(data => setAbout(data));
  }, [])

  return <>
    <h2 className='head-text'>
      Are looking for a
      developer who can <br />
      <span>create beautiful and
        functional websites.</span>
    </h2>
    <div className='app__profiles'>
      {about.map((item, index) => (
        <motion.div
          whileInView={{ opacity: 1 }}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className='app__profile-item'
          key={item.title + index}
        >
          <img src={urlFor(item.imgUrl)} alt='' />
          <h2 className='bold-text' style={{ marginTop: 20 }}>{item.title} </h2>
          <p className='p-text' style={{ marginTop: 10 }}> {item.description}</p>
        </motion.div>
      ))}
    </div>
  </>;
};

export default appWrap(MotionWrap(About, 'app__about'), 'about', 'app__whitebg');
